/* eslint-disable no-restricted-syntax */
export function transformSizmekUrl(url: string, name: string): string {
  const isPixel = [
    'click_audit_pixel',
    'pixel',
    'pixel_additional',
    'pixel_additional2',
  ].includes(name);
  const isLink = name === 'link';

  // Для pixel полей
  if (isPixel) {
    // Проверяем полный путь для pixel
    if (!url.includes('bs.serving-sys.ru/Serving/adServer.bs?cn=display')) {
      return url; // Не pixel аудита
    }

    // Заменяем ord на ord={RND}
    return url.replace(/([?&]ord=)[^&]*/g, '$1{RND}');
  }

  // Для link поля
  if (isLink) {
    // Проверяем только домен для link
    if (!url.includes('bs.serving-sys.ru')) {
      return url; // Не link Sizmek
    }

    let result = url;

    // Заменяем ord на ord={RND}
    result = result.replace(/([?&]ord=)[^&]*/g, '$1{RND}');

    // Обрабатываем erid
    const hasErid = /[?&]erid=/.test(result);

    if (hasErid) {
      // Заменяем значение erid на {ERID}$$
      result = result.replace(/([?&]erid=)[^&]*/g, '$1{ERID}$$$');
    } else {
      // Добавляем erid={ERID}$$
      result += `${result.includes('?') ? '&' : '?'}erid={ERID}$$$`;
    }

    return result;
  }

  // Для других полей - возвращаем как есть
  return url;
}

export function transformSizmekJs(jscode: string, name: string): string {
  if (name !== 'js_code_audit') {
    return jscode;
  }

  // Находим позицию src="..."
  const srcStart = jscode.indexOf('src="');
  if (srcStart === -1) return jscode;

  const urlStart = srcStart + 5; // после src="
  const urlEnd = jscode.indexOf('"', urlStart);
  if (urlEnd === -1) return jscode;

  const url = jscode.substring(urlStart, urlEnd);

  // Проверяем, что это Sizmek URL
  if (!url.includes('bs.serving-sys.ru')) {
    return jscode;
  }

  // Вручную обрабатываем URL
  const questionMarkIndex = url.indexOf('?');
  if (questionMarkIndex === -1) {
    return jscode;
  }

  const baseUrl = url.substring(0, questionMarkIndex);
  const queryString = url.substring(questionMarkIndex + 1);

  // Разбиваем параметры
  const params = queryString.split('&');
  const newParams: string[] = [];
  let hasErid = false;

  for (const param of params) {
    const equalsIndex = param.indexOf('=');
    if (equalsIndex === -1) {
      newParams.push(param);
    }

    const key = param.substring(0, equalsIndex);
    const value = param.substring(equalsIndex + 1);

    if (key === 'ord') {
      newParams.push('ord={RND}');
    } else if (key === 'erid') {
      newParams.push('erid={ERID}$$');
      hasErid = true;
    } else {
      newParams.push(`${key}=${value}`);
    }
  }

  // Добавляем erid если его не было
  if (!hasErid) {
    newParams.push('erid={ERID}$$');
  }

  // Собираем новый URL
  const newUrl = `${baseUrl}?${newParams.join('&')}`;

  // Заменяем URL в исходной строке
  return jscode.substring(0, urlStart) + newUrl + jscode.substring(urlEnd);
}

export function transformSizmekVastUrl(url: string, name: string): string {
  if (name !== 'data.vast_url') {
    return url;
  }

  if (!url.includes('bs.serving-sys.ru')) {
    return url;
  }

  try {
    const [base, query = ''] = url.split('?');
    if (!query) return url;

    const params = query
      .split('&')
      .map((param) => param.split('='))
      .reduce<Record<string, string>>((acc, [key, value = '']) => {
        // eslint-disable-next-line no-param-reassign
        acc[key] = value;
        return acc;
      }, {});

    // Обновляем параметры
    if (params.ord) params.ord = '{RND}';
    if (params.erid) params.erid = '{ERID}$$';

    const queryString = Object.entries(params)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

    return `${base}?${queryString}`;
  } catch (error) {
    console.error('Error transforming Sizmek VAST URL:', error);
    return url;
  }
}
